import React from 'react';
import PropTypes from 'prop-types';
import ToolbarButton from './ToolbarButton';

const DEFAULT_NODE = 'paragraph';

const hasBlock = (value, type) => value.blocks.some((node) => node.type === type);

const onClickBlock = (event, type, editor) => {
  event.preventDefault();
  const isActive = hasBlock(type);
  editor.setBlocks(isActive ? DEFAULT_NODE : type);
};

const ToolbarBlockButton = ({
  editor, type, icon, onClick, label,
}) => {
  const isActive = editor && hasBlock(editor.value, type);
  return (
    <ToolbarButton
      isActive={isActive}
      onClick={(event) => onClick(event, type, editor)}
      icon={icon}
      label={label}
    />
  );
};
ToolbarBlockButton.propTypes = {
  editor: PropTypes.objectOf(PropTypes.any).isRequired,
  type: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  label: PropTypes.string,
};
ToolbarBlockButton.defaultProps = {
  onClick: onClickBlock,
  label: '',
};

export default ToolbarBlockButton;
